import React from "react";
import { Link } from "gatsby";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import PortableText from "./portableText";
import Icon from "./icon";
import Container from "./container";

import * as styles from "../styles/components/featured-block.module.css";

function FeaturedBlock({ _key, title, _rawContent, link, image, switchOrder,caption,featureStyling }) {
  return (
    <div className={styles.root}>
      <Container>
        <div
          className={cn("grid", styles.grid, switchOrder && styles.switchOrder)}
          key={_key}
        >
          <div className={cn("col-12 col-lg-6", styles.text)}>
            <div className={styles.contentWrap}>
            {caption && (<div className={cn("h3", styles.subtitle)}>{caption}</div>)}
              {title && <h2 className="">{title}</h2>}
              {_rawContent && (
                <div className="entry-content">
                  <PortableText blocks={_rawContent} />
                </div>
              )}
              {link && link.url && (
                <>
                  {link.blank ? (
                    <a
                      href={link.url}
                      className="link"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.text}
                      <Icon symbol="arrow-right" />
                    </a>
                  ) : (
                    <Link to={link.url} className="link">
                      {link.text}
                      <Icon symbol="arrow-right" />
                    </Link>
                  )}
                </>
              )}
            </div>
          </div>
          <div className={cn("col-12 col-lg-6", styles.image)}>
            {image && image.asset && (
              <img
                src={imageUrlFor(buildImageObj(image)).auto("format").url()}
                alt={image.alt}
              />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default FeaturedBlock;
